/* import __COLOCATED_TEMPLATE__ from './connection-point.hbs'; */
/* RESPONSIBLE TEAM: team-proactive-support */
import { type SafeString } from 'handlebars';
import Component from '@glimmer/component';
import type ConnectionPoint from 'lib/graph-editor/addon/models/graph-editor/connection-point';
//@ts-ignore
import { sanitizeHtml } from '@intercom/pulse/lib/sanitize';

interface Args {
  connectionPoint: ConnectionPoint;
}

export default class GraphEditorNodeConnectionPointComponent extends Component<Args> {
  get style(): SafeString {
    return sanitizeHtml(`
      --x: ${this.args.connectionPoint.coordinates.x}px;
      --y: ${this.args.connectionPoint.coordinates.y}px;
    `);
  }
}
